module.exports = __webpack_public_path__ + "img/empty-cart.05d8cea1.gif";